<template>
  <div class="modal modal-invoice-edit fade fixed-end" tabindex="-1" role="dialog">
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Edit Invoice</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Raised</label>
            <input
              name="raised"
              v-model="form.raised"
              type="date"
              class="form-control"
              :class="errorClass('raised')"
              v-validate="'required'"
              data-vv-name="raised"
            />
            <help-block field="raised" />
          </div>

          <div class="mb-3">
            <label class="control-label">Due</label>
            <input
              name="due"
              v-model="form.due"
              type="date"
              class="form-control"
              :class="errorClass('due')"
              v-validate="'required'"
              data-vv-name="due"
            />
            <help-block field="due" />
          </div>

          <p class="text-muted small">
            Saving will sync the invoice to Xero with the updated dates.
          </p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-bs-dismiss="modal">
            Cancel
          </button>
          <ladda-button :on-click="save" class="btn btn-primary"
            >Save</ladda-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { CModal } from "@chameleon/chameleon-vue";
import { LaddaButton } from "components/form/input";
import { notify } from "utils";

export default {
  $_veeValidate: {
    validator: "new",
  },
  extends: CModal,
  components: { LaddaButton },

  props: {
    invoice: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      form: { raised: null, due: null },
    };
  },

  mounted() {
    this.addEventListener("open", () => {
      this.form = {
        raised: this.toDateInput(this.invoice.raised),
        due: this.toDateInput(this.invoice.due),
      };
      this.$validator.reset();
    });
  },

  methods: {
    ...mapActions("invoice", { updateInvoice: "updateSingle" }),

    toDateInput(value) {
      return value ? String(value).substring(0, 10) : null;
    },

    async save() {
      if (!(await this._validate())) {
        return Promise.reject();
      }

      return this.updateInvoice({
        id: this.invoice.id,
        payload: this.form,
      }).then(() => {
        notify.success("Invoice updated and queued to sync to Xero.");
        this.close();
      });
    },
  },
};
</script>